import { render, staticRenderFns } from "./BreakdownPamisList.vue?vue&type=template&id=90a523cc&scoped=true&"
import script from "./BreakdownPamisList.vue?vue&type=script&lang=js&"
export * from "./BreakdownPamisList.vue?vue&type=script&lang=js&"
import style0 from "./BreakdownPamisList.vue?vue&type=style&index=0&id=90a523cc&lang=scss&scoped=true&"
import style1 from "./BreakdownPamisList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a523cc",
  null
  
)

export default component.exports